export enum PermittedOperations {
    LIST_USER_DETAILS = 'ListUserDetails',
    CREATE_USER = 'CreateUser'
}

export enum PermittedCapabilities {
    CHANGE_ASSET_OWNERSHIP = 'CHANGE_ASSET_OWNERSHIP',
    MODIFY_EVERYTHING = 'MODIFY_EVERYTHING',
    READ_EVERYTHING = 'READ_EVERYTHING',
    MANAGE_GLOSSARY = 'MANAGE_GLOSSARY',
    MANAGE_PROPERTIES = 'MANAGE_CUSTOM_ATTRIBUTES',
    MANAGE_SYSTEMS = 'MANAGE_SYSTEMS'
}
